import type { IconSvgObject } from './types';

const Parabola03Icon: IconSvgObject = [
  ["path", { d: "M2 20H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 2C21 10.2831 16.9706 16.9978 12 16.9978C7.02944 16.9978 3 10.2831 3 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9.5 4.5L12 2L14.5 4.5M12 22V2.60878", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Parabola03Icon;
